import * as types from "../Types"

export const userRegisterReducer = (state = {}, action) => {
    switch(action.type){
        case types.USER_SIGN_UP_REQUEST:
            return {loading: true}
        case types.USER_SIGN_UP_SUCCESS:
            return {loading: false, userDetail:action.payload}
        case types.USER_SIGN_UP_FAIL:
            return {loading: false, error: action.payload}
        case types.USER_SIGN_UP_RESET:
            return {}
        default:
            return state
    }
}

export const userSignInReducer = (state ={}, action) => {
    switch(action.type){
        case types.USER_SIGN_IN_REQUEST:
            return {loading: true}
        case types.USER_SIGN_IN_SUCCESS:
            return {loading: false, userDetail:action.payload}
        case types.USER_SIGN_IN_FAIL:
            return {loading: false, error: action.payload}
        case types.USER_LOGOUT:
            return {}
        default:
            return state
    }
}

export const postCategoryReducer = (state = {}, action) => {
    switch(action.type){
        case types.POST_CATEGORY_REQUEST:
            return {loading: true}
        case types.POST_CATEGORY_SUCCESS:
            return {loading: false, categoryDetail: true}
        case types.POST_CATEGORY_FAIL:
            return {loading: false, error: action.payload}
        case types.POST_CATEGORY_RESET:
            return {}
        default:
            return state
    }
}

export const postItemReducer = (state = {}, action) => {
    switch(action.type){
        case types.POST_ITEM_REQUEST:
            return {loading: true}
        case types.POST_ITEM_SUCCESS:
            return {loading: false, itemDetail:true}
        case types.POST_ITEM_FAIL:
            return {loading: false, error: action.payload}
        case types.POST_ITEM_RESET:
            return {}
        default:
            return state
    }
}

export const getCategoryReducer = (state = {}, action) => {
    switch(action.type){
        case types.GET_CATEGORY_REQUEST:
            return {loading: true}
        case types.GET_CATEGORY_SUCCESS:
            return {loading: false, categoryDetail: action.payload}
        case types.GET_CATEGORY_FAIL:
            return {loading: false, error: action.payload}
        case types.GET_CATEGORY_RESET:
            return {}
        default:
            return state
    }
}